import React from 'react';
import useAppstoreRating from 'hooks/use-appstore-rating';

const AppRatingSchemaJsonLd = () => {
    const appRating = useAppstoreRating();

    return appRating ? (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    name: 'SpotHero',
                    url: 'https://spothero.com',
                    logo:
                        'http://spothero.com/static/main/img/common/spothero-logo-share.jpg',
                    contactPoint: {
                        '@type': 'ContactPoint',
                        telephone: '844-324-7768',
                        contactType: 'customer service',
                    },
                    sameAs: [
                        'https://www.facebook.com/SpotHero/',
                        'https://twitter.com/SpotHero',
                        'https://www.instagram.com/spothero/',
                    ],
                    owns: {
                        '@type': 'SoftwareApplication',
                        name: 'SpotHero',
                        operatingSystem: ['ANDROID', 'iOS'],
                        applicationCategory: 'Maps & Navigation',
                        aggregateRating: {
                            '@type': 'AggregateRating',
                            ratingValue: appRating.rating,
                            ratingCount: appRating.ratingCount,
                        },
                        offers: {
                            '@type': 'Offer',
                            price: '0',
                            priceCurrency: 'USD',
                        },
                    },
                }),
            }}
        />
    ) : null;
};

export default AppRatingSchemaJsonLd;
